import { CompanyInfoType } from 'components/features/cases/NextComponents/cases/moscow-exchange/title-case';
import BasicLink from 'core/BasicLink';
import ScrollAnimation from 'core/ScrollAnimation';
import { sanitize } from 'isomorphic-dompurify';
import Image from 'next/image';

import cn from './style.module.sass';

type TitleCaseBottomProps = CompanyInfoType;

export default function TitleCaseBottom({
    company,
    companyLink,
    text,
    mediaLinks,
    info,
    icon,
}: TitleCaseBottomProps) {
    return (
        <ScrollAnimation className={cn.titleCaseBottom}>
            <div className={cn['titleCaseBottom__left']}>
                <div className={cn['titleCaseBottom__item']}>
                    <div
                        dangerouslySetInnerHTML={{ __html: sanitize(company) }}
                        className={cn['titleCaseBottom__item-company']}
                    />
                    <div className={cn.linksContainer}>
                        {companyLink.map((link, index) => {
                            return (
                                <BasicLink
                                    key={`${link.name} + ${index}`}
                                    href={link.link}
                                    target="_blank"
                                    rel="noopener noreferrer nofollow"
                                    className={cn['titleCaseBottom__item-link']}
                                >
                                    <div
                                        dangerouslySetInnerHTML={{ __html: sanitize(link.name) }}
                                        className={cn['titleCaseBottom__item-link-content']}
                                    />
                                </BasicLink>
                            );
                        })}
                    </div>
                    <div
                        dangerouslySetInnerHTML={{ __html: sanitize(text) }}
                        className={cn['titleCaseBottom__item-text']}
                    />
                    {mediaLinks && (
                        <div className={cn['titleCaseBottom__media-links']}>
                            {mediaLinks.map(el => (
                                <BasicLink
                                    key={el.title}
                                    href={el.href}
                                    target="_blank"
                                    rel="noopener noreferrer nofollow"
                                >
                                    <div
                                        dangerouslySetInnerHTML={{ __html: sanitize(el.title) }}
                                        className={cn['titleCaseBottom__item-link-content']}
                                    />
                                </BasicLink>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            {info && icon && (
                <div className={cn.right}>
                    <div className={cn.block}>
                        <div
                            dangerouslySetInnerHTML={{ __html: sanitize(info) }}
                            className={cn.info}
                        />
                        <Image
                            src={icon}
                            alt="WDAIcon"
                            className={cn.img}
                            width={190}
                            height={63}
                        />
                    </div>
                </div>
            )}
        </ScrollAnimation>
    );
}
